import React, { useState } from "react";

const UtilityValidation = () => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [validityPeriod, setValidityPeriod] = useState("10 minutes");

  const validityOptions = [
    "30 seconds",
    "1 minute",
    "2 minutes",
    "5 minutes",
    "10 minutes",
    "30 minutes",
    "1 hour",
    "6 hours",
    "12 hours",
    "1 day",
  ];

  return (
    <div className="mb-2 bg-white p-6 rounded-lg border">
      <h2 className="text-lg font-medium text-gray-900 mb-4">
        Message validity period
      </h2>

      <div className="mb-6">
        <p className="text-sm text-gray-600 leading-relaxed">
          You can set a custom validity period that your utility message must be
          delivered by before it expires. If a message has not been delivered
          within this time frame, you will not be charged and your customer will
          not see the message.
        </p>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-medium text-gray-900 mb-2">
              Set custom validity period for your message
            </h3>
            <p className="text-sm text-gray-600">
              If you don't set a custom validity period, the standard 10 minutes
              WhatsApp message validity period will be applied.
            </p>
          </div>
          <div className="ml-4">
            <button
              onClick={() => setIsEnabled(!isEnabled)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                isEnabled ? "bg-blue-600" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  isEnabled ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <label
            htmlFor="validity-period"
            className="text-sm font-medium text-gray-700"
          >
            Validity period
          </label>
          <div className="relative">
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
        </div>

        <div className="relative">
          <select
            id="validity-period"
            value={validityPeriod}
            onChange={(e) => setValidityPeriod(e.target.value)}
            disabled={!isEnabled}
            className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${
              !isEnabled
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white text-gray-900"
            }`}
          >
            {validityOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default UtilityValidation;
